var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (components, continueBtnText, doneText, game, hasNarration, hasPrompt, i18n, prompt, submitUp, subtitle, undefined) {
if ( game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled)
{
buf.push("<div class=\"full-screen\"><div class=\"game-stepper text-lg text-bold\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div></div>");
}
buf.push("<div class=\"full-screen strikeout-canvas-container\"><canvas class=\"strikeout-canvas\"></canvas></div><div class=\"content-fill text-center\"><div class=\"content-fit block-v-lg content-md-fill content-sm-ver strikeout-words\"><div class=\"content-md-ver col-md-10 col-md-offset-1\"><h1 class=\"fade-in\">");
// iterate components
;(function(){
  var $$obj = components;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var word = $$obj[i];

if ( word.space)
{
buf.push(null == (jade_interp = "&nbsp;") ? "" : jade_interp);
}
else
{
buf.push("<div" + (jade.attr("data-replaces", word.incorrect && word.replaces, true, false)) + (jade.cls(['word',word.incorrect && "word-incorrect"], [null,true])) + "><div" + (jade.cls([word.klass], [true])) + ">" + (null == (jade_interp = word.incorrect || word.replaces) ? "" : jade_interp) + "</div></div>");
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var word = $$obj[i];

if ( word.space)
{
buf.push(null == (jade_interp = "&nbsp;") ? "" : jade_interp);
}
else
{
buf.push("<div" + (jade.attr("data-replaces", word.incorrect && word.replaces, true, false)) + (jade.cls(['word',word.incorrect && "word-incorrect"], [null,true])) + "><div" + (jade.cls([word.klass], [true])) + ">" + (null == (jade_interp = word.incorrect || word.replaces) ? "" : jade_interp) + "</div></div>");
}
    }

  }
}).call(this);

buf.push("</h1><h3>" + (null == (jade_interp = subtitle) ? "" : jade_interp) + "</h3></div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"components" in locals_for_with?locals_for_with.components:typeof components!=="undefined"?components:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"game" in locals_for_with?locals_for_with.game:typeof game!=="undefined"?game:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"subtitle" in locals_for_with?locals_for_with.subtitle:typeof subtitle!=="undefined"?subtitle:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}